import { useQuery } from '@tanstack/react-query';
import React from 'react';

import { fetchMerchantIsWoltPlus } from 'apis/merchant-gateway/merchant-analytics/api';
import Loading from 'core/Loading';
import { useIsMerchantV2ApiEnabled } from 'core/hooks/useIsMerchantV2ApiEnabled';
import { useMerchantContext } from 'modules/merchant/MerchantContext';

import InsightRoutes from '../InsightRoutes';
import useInsightV2WoltPlusHidden from '../hooks/useInsightV2WoltPlusHidden';

const FeatureMerchantInsights = () => {
  const { merchant, merchantVenues } = useMerchantContext();

  const { isWoltPlusHidden, isLoading: isLoadingWoltPlusHidden } = useInsightV2WoltPlusHidden(merchant.country);

  // With v2 the Wolt+ information is not a part of the merchant payload
  const { isMerchantV2ApiEnabled, isLoadingIsMerchantV2ApiEnabled } = useIsMerchantV2ApiEnabled();

  // Do not do the Wolt+ api call until we know it is needed
  const isFetchWoltPlusEnabled =
    !isWoltPlusHidden && !isLoadingWoltPlusHidden && !isLoadingIsMerchantV2ApiEnabled && isMerchantV2ApiEnabled;

  const merchantId = merchant.itemid.$oid;
  const { data: merchantIsWoltPlus, isLoading: isLoadingMerchantIsWoltPlus } = useQuery(
    ['/merchant-analytics-api/merchants/', merchantId, '/wolt-plus'],
    () => {
      if (!merchantId) {
        return;
      }
      return fetchMerchantIsWoltPlus(merchantId);
    },
    {
      enabled: isFetchWoltPlusEnabled,
      refetchOnWindowFocus: false,
    },
  );

  if (
    isLoadingWoltPlusHidden ||
    isLoadingIsMerchantV2ApiEnabled ||
    (isFetchWoltPlusEnabled && isLoadingMerchantIsWoltPlus)
  ) {
    return <Loading />;
  }

  const isWoltPlus = isMerchantV2ApiEnabled ? !!merchantIsWoltPlus : !!merchant.is_part_of_wolt_plus;
  const activeVenues = merchantVenues?.filter(venue => venue.status === 'VENUE_PUBLISHED');

  return (
    <InsightRoutes
      insightEntity={{
        type: 'merchant',
        id: merchant.itemid.$oid,
        isWoltPlus: !isWoltPlusHidden && isWoltPlus,
        merchant,
        venues: activeVenues,
        country: merchant.country,
      }}
    />
  );
};

export default FeatureMerchantInsights;
